import { Download, LanguageSwitcher, Languages, Hero, Features, TestimonialsAndGameModes } from './components';

const App = () => {
  return (
    <>
      <LanguageSwitcher />
      <Hero />
      <Features />
      <TestimonialsAndGameModes />
      <Languages />
      <Download />
    </>
  );
}

export default App;
